module Bookhus.SearchWidget {

    enum SearchFilterType {
        Opvaskemaskine,
        Vaskemaskine,
        Tørretumbler,
        Husdyr,
        Rygning,
        Brændeovn,
        Internet,
        Parabol,
        Handicapvenligt,
        Havudsigt,
        MaxPrice,
        Spa,
        Sauna,
        PoolOut,
        PoolIn,
        Garage,
        Boat,
        Ekkolod,
        VhsRadio,
        Radar,
        MinTwoToilets,
        Fiskerenseplads,
        Mikroovn,
        Cykler,
        Feriecenter,
        Swimmingpool,
        Hus,
        Lejlighed,
        Skiområde,
        Storby,
        Bjergby,
        UdsigtVand,
        UdsigtNatur,
        LadeStander,
        Varmepumpe,
        HusdyrIkkeTilladt
    }

    interface IControlSettings {
        showPeriod: boolean;
        maxPeriodDays: number;
        selectedPeriodDay: number;

        showRooms: boolean;
        maxRooms: number;

        showPersons: boolean;
        maxPersons: number;

        showDistanceToSea: boolean;
        showDistanceToGrocer: boolean;
        showArea: boolean;
        showRelationship: boolean;

        useGeoLocation: boolean;
        useGeographicAndLocationsInSearch: boolean
        geoLocationData: string;

        facilities: SearchFilterType[];
    }

    export interface ISearchWidgetOptions {

        callSearchWhenInitiated: boolean;
        search: (filters: ISearchCridentials) => void;
        searchBaseFilterUri: string;

        customClass: string;

        controlSettings: IControlSettings
        showTimeCalendarStrip?: boolean;
        showTagsAsButtons: boolean;
    }

    export class SearchWidgetWide {

        private container: JQuery;
        private searchContainer: JQuery;
        private extSearchContainer: JQuery;


        private options: ISearchWidgetOptions;
        private dataService: SearchwidgetDataservice;
        private isApplyingSearchFilter: boolean = false;

        constructor(selector: string, options: Partial<ISearchWidgetOptions>) {
            if (selector == "" || !selector) {
                return;
            }

            this.setOptions(options);

            this.dataService = new SearchwidgetDataservice();

            this.container = $(selector);
            this.buildContainer();
        }

        private getSearchWidgetLanguage(): any {
            var bookhus = (window as any).Bookhus;
            if (bookhus
                && bookhus.Localization
                && bookhus.Localization.Standard
                && bookhus.Localization.Standard.UI
                && bookhus.Localization.Standard.UI.Widgets) {
                return bookhus.Localization.Standard.UI.Widgets.SearchWidget;
            }
            return null;
        }

        private getGeneralTextLanguage(): any {
            var bookhus = (window as any).Bookhus;
            if (bookhus
                && bookhus.Localization
                && bookhus.Localization.Standard
                && bookhus.Localization.Standard.UI) {
                return bookhus.Localization.Standard.UI.GeneralText;
            }
            return null;
        }

        private translate(name: string): string {
            var searchWidgetLanguage = this.getSearchWidgetLanguage();
            if (!searchWidgetLanguage) {
                return "";
            }

            switch (name) {
                case "HavDistance":
                    return searchWidgetLanguage.HavDistance || searchWidgetLanguage.Hav || "";
                case "KøbmandDistance":
                    return searchWidgetLanguage.KøbmandDistance || searchWidgetLanguage.Købmand || "";
                case "MaxPrice":
                    return searchWidgetLanguage.MaxPrice || searchWidgetLanguage["Maks pris"] || "";
                case "Search":
                    return searchWidgetLanguage.Search || searchWidgetLanguage.Søg || "";
                default:
                    return searchWidgetLanguage[name] || "";
            }
        }

        private translateGeneralText(name: string, fallback: string): string {
            var generalTextLanguage = this.getGeneralTextLanguage();
            var value = generalTextLanguage ? generalTextLanguage[name] : null;
            return value || fallback;
        }

        private buildContainer(): void {
            this.container.addClass(`container card p-3 ${this.options.customClass}`);

            var { controlSettings } = this.options;
            var showExtendedSearch = controlSettings.showDistanceToGrocer || controlSettings.showDistanceToSea || (controlSettings.facilities && controlSettings.facilities.length > 0)

            this.container.html(`
                <h4 class="font-weight-bold mb-3">${this.translate('SearchProperties')}</h4>
                <div class="row pb-2" id="searchContainer"></div>
                <div class="d-flex justify-content-between align-items-center">
					${(showExtendedSearch ? `<a data-toggle="collapse" href="#searchMore"  class="text-secondary text-decoration-none"><i class="icon-ic_more_home mr-2"></i>${this.translate("AdvancedSearch")}</a>` : '')}

                    <button type="button" class="btn btn-outline-dark ml-auto mr-3" data-command="resetfilters">${this.translate("Nulstil")}</button>
                    <button type="button" class="btn btn-primary btnWidth" data-command="search">${this.translate("Search")}</button>
				</div>
                ${(showExtendedSearch ? '<div class="collapse pt-3" id="searchMore"></div>' : '')}
            `);

            this.searchContainer = this.container.find('#searchContainer');
            this.extSearchContainer = $("div#searchMore");
        }

        private setOptions(options: Partial<ISearchWidgetOptions>) {
            this.options = $.extend(true, {
                callSearchWhenInitiated: false,
                search: (filters: ISearchCridentials) => {
                    var params = $.param(filters);
                    window.location.href = this.options.searchBaseFilterUri + '?' + params;
                },
                customClass: '',
                loadGeoLocationWidget: false,
                searchBaseFilterUri: '',
                showTimeCalendarStrip: false,
                showTagsAsButtons: false,
                controlSettings: {
                    showPeriod: true,
                    maxPeriodDays: 14,
                    selectedPeriodDay: 6,

                    showRooms: true,
                    maxRooms: 7,

                    showPersons: true,
                    maxPersons: 20,

                    showDistanceToSea: false,
                    showDistanceToGrocer: false,
                    showArea: true,
                    showRelationship: false,
                    useGeoLocation: false,
                    useGeographicAndLocationsInSearch: false,
                    geoLocationData: "",
                    facilities: [] as SearchFilterType[]
                } as IControlSettings
            } as ISearchWidgetOptions, options);

            if (this.options.controlSettings.selectedPeriodDay >= this.options.controlSettings.maxPeriodDays) {
                this.options.controlSettings.selectedPeriodDay = this.options.controlSettings.maxPeriodDays - 1;
            }
        }


        public init() {
            document.addEventListener('controls_rendered', () => {
                this.isApplyingSearchFilter = true;
                const hasSearchFilter = this.setSearchFilter();
                this.isApplyingSearchFilter = false;
                this.renderTimeCalendarStrip();

                if (hasSearchFilter || this.options.callSearchWhenInitiated) {
                    this.loadFilteredData();
                }
            });

            this.renderFilters();
            this.renderFacilities();
            this.initEvents();
            this.bindTimeCalendarStripEvents();
            this.renderTimeCalendarStrip();
        }

        private timeStripOffset: number = 0;
        private timeStripDaysToShow: number = 6;

        private formatDateForStartInput(date: Date): string {
            return $.datepicker.formatDate(
                $.datepicker.regional.bookhuscurrent == "en-GB" ? "mm/dd/yy" : "dd-mm-yy",
                date
            );
        }

        private parseStartDateValue(value: string): Date {
            if (!value) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return today;
            }

            const localizedFormat = $.datepicker.regional.bookhuscurrent == "en-GB" ? "mm/dd/yy" : "dd-mm-yy";
            const formats = ["yy-mm-dd", localizedFormat, "dd/mm/yy"];

            for (const format of formats) {
                try {
                    const parsed = $.datepicker.parseDate(format, value);
                    parsed.setHours(0, 0, 0, 0);
                    return parsed;
                } catch {
                }
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return today;
        }

        private sameDate(a: Date, b: Date): boolean {
            return a.getFullYear() === b.getFullYear()
                && a.getMonth() === b.getMonth()
                && a.getDate() === b.getDate();
        }

        private setTimeStripOffsetFromDate(date: Date): void {
            if (!this.options.showTimeCalendarStrip || !date) {
                return;
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0);
            date.setHours(0, 0, 0, 0);
            if (isNaN(date.getTime())) {
                return;
            }

            const daysFromToday = Math.floor((date.getTime() - today.getTime()) / 86400000);
            this.timeStripOffset = Math.max(0, daysFromToday - (daysFromToday % this.timeStripDaysToShow));
        }

        private getStripMonthTitle(date: Date): string {
            const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAJ', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'];
            return `${months[date.getMonth()]} ${date.getFullYear()}`;
        }

        private getStripWeekday(date: Date): string {
            const days = ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'];
            return days[date.getDay()];
        }

        private renderTimeCalendarStrip(): void {
            if (!this.options.showTimeCalendarStrip) {
                return;
            }

            const $strip = $('#catalogTimeCalendarStrip');
            const $title = $('#catalogTimeCalendarStripMonth');
            const $startDate = $('#startDate');

            if ($strip.length === 0 || $title.length === 0 || $startDate.length === 0) {
                return;
            }

            const selectedDate = this.parseStartDateValue(String($startDate.val() || ''));
            const baseDate = new Date();
            baseDate.setHours(0, 0, 0, 0);
            baseDate.setDate(baseDate.getDate() + this.timeStripOffset);

            $title.text(this.getStripMonthTitle(baseDate));
            $strip.empty();

            const prevDisabled = this.timeStripOffset <= 0;

            $strip.append(`
        <div class="catalog-time-card catalog-time-card-prev ${prevDisabled ? 'disabled' : ''}" id="catalogTimeCalendarStripPrev">
            <span>&larr;</span>
        </div>
    `);

            for (let i = 0; i < this.timeStripDaysToShow; i++) {
                const current = new Date(baseDate);
                current.setDate(baseDate.getDate() + i);

                const isToday = i === 0 && this.timeStripOffset === 0;
                const isActive = this.sameDate(current, selectedDate);
                const label = isToday ? 'Today' : this.getStripWeekday(current);
                const day = current.getDate();

                $strip.append(`
            <div class="catalog-time-card ${isActive ? 'active' : ''}" data-date="${this.formatDateForStartInput(current)}">
                <div class="catalog-time-card-inner">
                    <div class="catalog-time-card-label">${label}</div>
                    <div class="catalog-time-card-day">${day}</div>
                </div>
            </div>
        `);
            }

            $strip.append(`
        <div class="catalog-time-card catalog-time-card-next" id="catalogTimeCalendarStripNext">
            <span>&rarr;</span>
        </div>
    `);
        }



        private bindTimeCalendarStripEvents(): void {
            if (!this.options.showTimeCalendarStrip) {
                return;
            }

            $(document)
                .off('click.timeCalendarStrip', '#catalogTimeCalendarStrip .catalog-time-card[data-date]')
                .on('click.timeCalendarStrip', '#catalogTimeCalendarStrip .catalog-time-card[data-date]', (e) => {
                    const $target = $(e.currentTarget);
                    const value = String($target.data('date') || '');
                    const currentValue = String($('#startDate').val() || '');

                    if (currentValue === value) {
                        this.renderTimeCalendarStrip();
                        return;
                    }

                    const parsed = this.parseStartDateValue(value);
                    $('#startDate').datepicker('setDate', parsed).trigger('change');

                    this.renderTimeCalendarStrip();
                });

            $(document)
                .off('click.timeCalendarStripPrev', '#catalogTimeCalendarStripPrev')
                .on('click.timeCalendarStripPrev', '#catalogTimeCalendarStripPrev', () => {
                    if (this.timeStripOffset <= 0) {
                        return;
                    }

                    this.timeStripOffset = Math.max(0, this.timeStripOffset - this.timeStripDaysToShow);
                    this.renderTimeCalendarStrip();
                });

            $(document)
                .off('click.timeCalendarStripNext', '#catalogTimeCalendarStripNext')
                .on('click.timeCalendarStripNext', '#catalogTimeCalendarStripNext', () => {
                    this.timeStripOffset += this.timeStripDaysToShow;
                    this.renderTimeCalendarStrip();
                });

            $(document)
                .off('change.timeCalendarStrip', '#startDate')
                .on('change.timeCalendarStrip', '#startDate', () => {
                    this.setTimeStripOffsetFromDate(this.parseStartDateValue(String($('#startDate').val() || '')));
                    this.renderTimeCalendarStrip();
                });
        }


        private renderFilters() {
            var self = this;
            var { controlSettings } = this.options;
            var controls = "";
            var locationPromise = null;
            if (
                controlSettings.useGeoLocation && controlSettings.useGeographicAndLocationsInSearch && controlSettings.geoLocationData.indexOf("checked") > -1 ||
                controlSettings.useGeoLocation && controlSettings.geoLocationData.indexOf("checked") > -1) {

                controls += `
                    <div class="col-lg-4">
                        <div class="form-group">
						    <label class="mb-1" >${self.translate("Område")}</label>
						    <div id="geoLocationWidgetContainer">
                            </div>
					    </div>
                    </div>
                `;
            } else if (controlSettings.showArea) {

                controls += `
                    <div class="col-lg-4">
                        <div class="form-group">
						    <label class="mb-1" >${self.translate("Område")}</label>
						    <select class="form-control" id="locations" name="lokation" data-searchable="true" aria-labelledby="areaLabel">
							    <option value="0">${self.translate("IkkeValgt")}</option>
						    </select>
					    </div>
                    </div>
                `;
            }

            var tagsPromise = null;

            if (self.options.showTagsAsButtons) {
                controls += `
                        <div class="col-12 mb-3">
                            <div class="form-group time-tags-group">
                                <label id="tagsLabel" class="mb-2">Tags</label>
                                <div id="timeTags" class="time-tags-buttons"></div>
                                <input type="hidden" id="selectedTags" name="tags" />
                            </div>
                        </div>
                    `;
                            } else {
                                controls += `
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label id="tagsLabel" class="mb-1">Tags</label>
                                <select class="form-control" id="tags" multiple="multiple" name="tags" aria-labelledby="tagsLabel"></select>
                            </div>
                        </div>
                    `;
            }

            var select2Promise = null;
            if (!self.options.showTagsAsButtons && typeof $.fn.select2 !== "function") {
                if (!document.querySelector('link[data-search-widget-select2]')) {
                    $('head').append('<link data-search-widget-select2 href="https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css" rel="stylesheet" type="text/css">');
                }
                select2Promise = $.ajax({
                    url: "https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js",
                    dataType: "script",
                    cache: true,
                    timeout: 10000
                }).then(() => {}, () => {
                    // Keep the native multiple select usable when the CDN is unavailable.
                    console.warn("Select2 could not be loaded; using the native tag selector.");
                });
            }

            tagsPromise = this.dataService.loadLocations().then(() => {
                var locationData = this.dataService.locations || [];

                if (self.options.showTagsAsButtons) {
                    var tagButtons = "";
                    for (var i = 0; i < locationData.length; i++) {
                        tagButtons += `
                <button type="button"
                        class="btn btn-outline-secondary btn-sm time-tag-btn me-2 mb-2"
                        data-tag-id="${locationData[i].id}">
                    ${locationData[i].name}
                </button>
            `;
                    }
                    $('#timeTags').html(tagButtons);
                } else {
                    var locations = "";
                    for (var i = 0; i < locationData.length; i++) {
                        locations += `<option value="${locationData[i].id}">${locationData[i].name}</option>`;
                    }
                    $('#tags').append(locations);


                }
            });


            var relationshipPromise = null;
            if (controlSettings.showRelationship) {
                controls += `
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label id="relationshipLabel" class="mb-1" >${self.translateGeneralText("Relationship", self.translate("Relationship"))}</label>
                                <select class="form-control" id="relationship" name="relationship" aria-labelledby="relationshipLabel">
									<option value="-1">${self.translate("IkkeValgt")}</option>
								</select>
                            </div>
                        </div>
                    `;
                relationshipPromise = this.dataService.loadRelationship().then(() => {
                    var relationshipData = this.dataService.relationships || [];
                    var relationships = "";
                    for (var i = 0; i < relationshipData.length; i++) {
                        relationships += `<option value="${relationshipData[i].id}">${relationshipData[i].name}</option>`;
                    }
                    $('#relationship').append(relationships);
                });
            }

            if (controlSettings.showRooms || controlSettings.showPersons) {
                var roomControl = "";
                if (controlSettings.showRooms) {
                    var rooms = "";
                    for (var i = 2; i <= (controlSettings.maxRooms || 4); i++) {
                        rooms += `<option value="${i}">${i} ${self.translate("Værelser")}</option>`;
                    }
                    roomControl = `
                        <div class="col-4 pr-0">
						    <div class="form-group">
							    <label id="roomcountLabel" class="mb-1" >${self.translate("Værelser")}</label>
                                <select class="form-control" name="roomcount" data-searchable="true" aria-labelledby="roomcountLabel">
                                    <option value="0">${self.translate("IkkeValgt")}</option>
                                    <option value="1">1 ${self.translate("Værelse")}</option>
                                    ${rooms}
                                </select>
						    </div>
					    </div>
                    `;
                }

                var personControl = "";
                if (controlSettings.showPersons) {
                    var persons = "";
                    for (var i = 2; i <= (controlSettings.maxPersons || 8); i++) {
                        persons += `<option value="${i}">${i} ${self.translate("Personer")}</option>`;
                    }
                    personControl = `
                        <div class="col">
							<div class="form-group">
								<label id="personCountLabel" class="mb-1" >${self.translate("Personer")}</label>
								<select class="form-control" name="personcount" data-searchable="true" aria-labelledby="personCountLabel">
									<option value="0">${self.translate("IkkeValgt")}</option>
                                    <option value="1">1 ${self.translate("Person")}</option>
                                    ${persons}
								</select>
							</div>
						</div>
                    `;
                }

                controls += `
                    <div class="col-lg-4">
                        <div class="row">
                            ${roomControl}
                            ${personControl}
                        </div>
                    </div>
                `;
            }

            if (controlSettings.showPeriod) {
                var weeks = `<option value="0">1 ${self.translate("Dag")}</option>`;
                for (var i = 1; i < (controlSettings.maxPeriodDays || 28); i++) {
                    var tekst = "";
                    if ((i + 1) % 7 == 0) {
                        var week = (i + 1) / 7;
                        if (week == 1) {
                            tekst = week + " " + self.translate("Uge");
                        }
                        else {
                            tekst = week + " " + self.translate("Uger");
                        }
                    }
                    else {
                        tekst = (i + 1) + " " + self.translate("Dage");
                    }
                    weeks += `<option ${i == controlSettings.selectedPeriodDay ? "selected" : ""} value="${i}">${tekst}</option>`;
                }

                controls += `
                        <div class="col-md-8">
                            <div class="form-group time-period-group ${self.options.showTimeCalendarStrip ? 'time-active' : ''}">
                                <label>${self.translate("Periode")}</label>
                                <div class="row time-period-fields">
                                    <div class="col-md-6 time-period-start">
                                        <input type="text"
                                               id="startDate"
                                               name="arrivalDate"
                                               placeholder="${self.translate("StartDato")}"
                                               class="datePicker form-control"
                                               data-searchable="true"
                                               data-keyup="true"
                                               aria-label="Startdato" />
                                        <input type="hidden" id="endDate" name="departureDate" />
                                        <input type="hidden" id="houseIds" name="houseIds" />
                                    </div>
                                    <div class="col-md-6 time-period-length">
                                        <select class="form-control" id="periodWeeks" name="days" data-searchable="true" aria-label="Periodens længde">
                                            ${weeks}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;

                                if (self.options.showTimeCalendarStrip) {
                                    controls += `
                        <div class="col-12">
                            <div class="catalog-time-strip-wrapper">
                                <div class="catalog-time-strip-month mb-3" id="catalogTimeCalendarStripMonth"></div>
                                <div class="catalog-time-strip-row" id="catalogTimeCalendarStrip"></div>
                            </div>
                        </div>
                    `;
                }
            }

     

            self.searchContainer.html(controls);
            self.applySearchFilterValues(self.parseQueryString(location.search.substring(1)));
            

            var controlRenderedEvent = new CustomEvent('controls_rendered');
            var controlsRenderedDispatched = false;
            var dispatchControlsRendered = () => {
                if (controlsRenderedDispatched) {
                    return;
                }

                controlsRenderedDispatched = true;
                window.setTimeout(() => {
                    document.dispatchEvent(controlRenderedEvent);
                }, 0);
            };

            if (controlSettings.useGeoLocation) {
                var geoLocationWidget = new Bookhus.SearchWidget.GeoLocationWidget("#geoLocationWidgetContainer", {
                    customClass: '',
                    treeData: this.options.controlSettings.geoLocationData,
                });
                geoLocationWidget.init();
            }

            if (!self.options.showTagsAsButtons) {
                tagsPromise = $.when(tagsPromise, select2Promise).then(() => {
                    if (typeof $.fn.select2 === "function") {
                        $("#tags").select2({
                            placeholder: self.translate("ChooseTags"),
                            tokenSeparators: [',', ' ']
                        });
                    }
                });
            }

            var promiseArray = [];
            if (tagsPromise) {
                promiseArray.push(tagsPromise);
            }
            if (relationshipPromise) {
                promiseArray.push(relationshipPromise);
            }
            if (promiseArray.length > 0) {
                ($.when as any).apply($, promiseArray).always(dispatchControlsRendered);
                window.setTimeout(dispatchControlsRendered, 500);
            }
            else {
                dispatchControlsRendered();
            }
        }

        private renderFacilities() {
            var self = this;
            var { controlSettings } = this.options;

            var controlGroup = "";
            if (controlSettings.showDistanceToSea || controlSettings.showDistanceToGrocer) {

                var distanceToSeaControl = "";
                if (controlSettings.showDistanceToSea) {
                    distanceToSeaControl = `
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label id="havDistanceLabel" class="mb-1 font-weight-bold" >${self.translate("HavDistance")}</label>
                                <select class="form-control" name="havDistance" aria-labelledby="havDistanceLabel">
									<option value="-1">${self.translate("IkkeValgt")}</option>
                                    <option value="1">${self.translate("Under")} 100m</option>
                                    <option value="2">${self.translate("Under")} 200m</option>
                                    <option value="3">${self.translate("Under")} 500m</option>
                                    <option value="4">${self.translate("Under")} 1000m</option>
                                    <option value="5">${self.translate("Under")} 2000m</option>
                                    <option value="6">${self.translate("Under")} 3000m</option>
								</select>
                            </div>
                        </div>
                    `;
                }

                var distanceToGrocer = "";
                if (controlSettings.showDistanceToGrocer) {
                    distanceToGrocer += `
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label id="groceryStoreDistanceLabel" class="mb-1 font-weight-bold">${self.translate("KøbmandDistance")}</label>
                            <select class="form-control" name="købmandDistance" aria-labelledby="groceryStoreDistanceLabel">
                                <option value="-1">${self.translate("IkkeValgt")}</option>
                                <option value="1">${self.translate("Under")} 100m</option>
                                <option value="2">${self.translate("Under")} 200m</option>
                                <option value="3">${self.translate("Under")} 500m</option>
                                <option value="4">${self.translate("Under")} 1000m</option>
                                <option value="5">${self.translate("Under")} 2000m</option>
                                <option value="6">${self.translate("Under")} 3000m</option>
                            </select>
                        </div>
                    </div>
                `;
                }

                controlGroup = `
                    <div class="row pb-3">
                        ${distanceToSeaControl}
                        ${distanceToGrocer}
					</div>
                `;
            }

            var facilityGroup = "";
            var filters = controlSettings.facilities || [];            
            if (filters.length > 0) {
                var facilities = "";

                for (var i = 0; i < filters.length; i++) {
                    var filter = filters[i];
                    facilities += `
                        <div class="col-6 col-lg-3">
							<label class="custom-control custom-checkbox d-flex align-items-center">
								<input type="checkbox" name="${SearchFilterType[filter]}" class="custom-control-input">
								<span class="custom-control-label"><i class="mr-2 ml-2 ${self.dataService.GetCssIcon(filter)} mt-1 d-inline-block"></i> ${self.translate(SearchFilterType[filter])}</span>
							</label>
						</div>
                    `;
                }

                facilityGroup = `
                    <div class="form-group mb-0">
                        <label class="mb-1 font-weight-bold">${self.translate("Faciliteter")}</label>
                        <div class="row font-size-1">
                            ${facilities}
                        </div>
                    </div>
                `;
            }

            var html = `
                ${controlGroup}
                ${facilityGroup}
            `;
            self.extSearchContainer.html(html);
        }

        private initEvents() {
            var self = this;
            $('#startDate').datepicker({
                showWeek: true,
                ...($.datepicker.regional.bookhuscurrent == "en-GB" && { dateFormat: 'mm/dd/yy' } )
            });

            $('[data-command="resetfilters"]').on('click', (e) => {
                $(self.container.find('input, select, textarea')).each((index, element) => {
                    var current = $(element);

                    if (current.prop('type') == "checkbox") {
                        current.prop('checked', false);
                        current.prop('indeterminate', false);
                        return;
                    }
                    if (current.attr('name') == "days") {
                        current.val('6');
                        return;
                    }

                    if (current.attr('name') == "købmandDistance" || current.attr('name') == "havDistance") {
                        current.val('-1');
                        return;
                    }


                    if (current.prop('nodeName') == "INPUT" || current.prop('nodeName') == "TEXTAREA") {
                        current.val('');
                        return;
                    }
                    if (current.prop('nodeName') == "SELECT") {
                        current.val('0');
                        return;
                    }


                });

                self.loadFilteredData();
            });

            $('[data-command="search"]').on('click', (e) => {
                self.loadFilteredData();
            });

            self.container
                .off('change.searchWidgetPets', 'input[name="Husdyr"], input[name="HusdyrIkkeTilladt"]')
                .on('change.searchWidgetPets', 'input[name="Husdyr"], input[name="HusdyrIkkeTilladt"]', function () {
                    var current = $(this);
                    if (!current.is(':checked')) {
                        return;
                    }

                    var oppositeName = current.attr('name') === 'Husdyr' ? 'HusdyrIkkeTilladt' : 'Husdyr';
                    self.container.find(`input[name="${oppositeName}"]`).prop('checked', false);
                });

            $(document)
                .off('click.searchWidgetTimeTags', '.time-tag-btn')
                .on('click.searchWidgetTimeTags', '.time-tag-btn', function () {
                $(this).toggleClass('active btn-primary').toggleClass('btn-outline-secondary');

                var selected: string[] = [];
                $('.time-tag-btn.active').each(function () {
                    selected.push(String($(this).data('tag-id')));
                });

                $('#selectedTags').val(selected.join(','));
                self.loadFilteredData();
            });

            $("#locations, #relationship, #tags, #startDate, select[name='days'], select[name='roomcount'], select[name='personcount'], input[name='GeoLokation']").change((e) => {
                if (self.isApplyingSearchFilter) {
                    return;
                }

                self.loadFilteredData();
            });

            //self.container.find('[data-searchable="true"], .ExtendedSearch input, .ExtendedSearch select').on('change', (index, element) => {
            //    self.loadFilteredData();
            //});

            self.container.find('[data-keyup="true"]').on('keyup', () => {
                self.debounce(self.loadFilteredData(), 100, false);
            });
        }

        private applySearchFilterValues(cridentials: any): void {
            var self = this;

            for (var key in cridentials) {
                if (!cridentials.hasOwnProperty(key)) {
                    continue;
                }

                var element = $('[name="' + key + '"]');
                var value = cridentials[key];

                if (key === "tags") {
                    var tagValues = self.getFilterValues(value);

                    if (self.options.showTagsAsButtons) {
                        self.setTimeTagButtons(tagValues);
                    } else if (element.length) {
                        element.val(tagValues);

                        if (element.data("select2-id") != undefined) {
                            element.trigger('change.select2');
                        }
                    }

                    continue;
                }

                if (element.length === 0) {
                    continue;
                }

                if (key === "arrivalDate") {
                    var parsedArrivalDate = self.parseStartDateValue(String(value));

                    try {
                        element.datepicker('setDate', parsedArrivalDate);
                    } catch {
                        element.val(self.formatDateForStartInput(parsedArrivalDate));
                    }

                    self.setTimeStripOffsetFromDate(parsedArrivalDate);
                    continue;
                }

                if (element.attr('type') === 'checkbox') {
                    element.prop('checked', value == "true");
                } else if (element.data("select2-id") != undefined) {
                    element.val(value).trigger('change.select2');
                } else {
                    element.val(value);
                }

            }

            var petsAllowed = self.container.find('input[name="Husdyr"]');
            var petsNotAllowed = self.container.find('input[name="HusdyrIkkeTilladt"]');
            if (petsAllowed.is(':checked') && petsNotAllowed.is(':checked')) {
                petsNotAllowed.prop('checked', false);
            }
        }

        private setSearchFilter() {
            var self = this;

            var search = location.search.substring(1);
            var cridentials = self.parseQueryString(search);

            self.applySearchFilterValues(cridentials);

            return search.length > 0;
        }

        private parseQueryString(search: string): any {
            var result: any = {};

            if (!search) {
                return result;
            }

            var parts = search.split('&');
            for (var i = 0; i < parts.length; i++) {
                if (!parts[i]) {
                    continue;
                }

                var pair = parts[i].split('=');
                var key = decodeURIComponent((pair.shift() || '').replace(/\+/g, ' ')).replace(/\[\]$/, '');
                var value = decodeURIComponent(pair.join('=').replace(/\+/g, ' '));

                if (!key) {
                    continue;
                }

                if (result[key] == undefined) {
                    result[key] = value;
                } else if ($.isArray(result[key])) {
                    result[key].push(value);
                } else {
                    result[key] = [result[key], value];
                }
            }

            return result;
        }

        private getFilterValues(value: any): string[] {
            var values: string[] = [];
            var source = $.isArray(value) ? value : [value];

            for (var i = 0; i < source.length; i++) {
                var parts = String(source[i]).split(',');

                for (var j = 0; j < parts.length; j++) {
                    var item = $.trim(parts[j]);

                    if (item.length > 0 && $.inArray(item, values) === -1) {
                        values.push(item);
                    }
                }
            }

            return values;
        }

        private setTimeTagButtons(tagValues: string[]): void {
            var selectedTags: any = {};

            for (var i = 0; i < tagValues.length; i++) {
                selectedTags[String(tagValues[i])] = true;
            }

            $('.time-tag-btn').each(function () {
                var $button = $(this);
                var isSelected = selectedTags[String($button.data('tag-id'))] === true;

                $button
                    .toggleClass('active btn-primary', isSelected)
                    .toggleClass('btn-outline-secondary', !isSelected);
            });

            $('#selectedTags').val(tagValues.join(','));
        }

        private loadFilteredData() {
            var filters = this.getFilters();
            this.options.search(filters);
        }

        private getFilters(): ISearchCridentials {
            var self = this;
            var filters = {} as ISearchCridentials;

            $(self.container.find('input, select, textarea')).each((index, element) => {
                var current = $(element);
                if (current.attr('name') == undefined) {
                    return;
                }

                if (current.prop('type') == "checkbox" && current.attr('value') != undefined) {
                    if (!current.is(':checked')) {
                        return;
                    }

                    var propertyKey = current.attr('name');
                    var propertyValue = filters[propertyKey];

                    if (propertyValue == undefined || propertyValue == null) {
                        filters[propertyKey] = current.val();
                    }
                    else if (Array.isArray(filters[propertyKey])) {
                        filters[propertyKey].push(current.val());
                    }
                    else {
                        filters[propertyKey] = [propertyValue, current.val()];
                    }
                } else if (current.prop('type') == "checkbox") {
                    filters[current.attr('name')] = current.is(':checked');
                }
                else {
                    var value = current.val();

                    if (current.attr('name') == 'tags' && typeof value === 'string' && value.indexOf(',') > -1) {
                        filters[current.attr('name')] = value.split(',');
                        return;
                    }

                    if (current.attr('name') === 'arrivalDate' && typeof value === "string") {
                        value = this.fixDateFormat(value, $.datepicker.regional.bookhuscurrent);
                    }

                    filters[current.attr('name')] = value;
                }
            });

            return filters;
        }

        private fixDateFormat(dateStr: string, culture: string = "da"): string {
            if (!dateStr) {
                return dateStr;
            }

            const localizedFormat = culture === 'en-GB' ? 'mm/dd/yy' : 'dd-mm-yy';
            const formats = ['yy-mm-dd', localizedFormat, 'dd/mm/yy'];

            for (const format of formats) {
                try {
                    const parsed = $.datepicker.parseDate(format, dateStr);
                    return $.datepicker.formatDate('yy-mm-dd', parsed);
                } catch {
                }
            }

            return dateStr;
        }

        private debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }
    }
}
